import { Pipe, PipeTransform } from '@angular/core';
import { DataPoint, Record } from '@mtna/data-core-ts';
import { instanceOfCode, Variable } from '@mtna/pojo-consumer-ts';
import { RdsCodeDisplayType } from '@rds/shared-api';

@Pipe({
  name: 'rdsGetRecordValue',
})
export class RdsGetRecordValuePipe implements PipeTransform {
  transform(type: RdsCodeDisplayType, record: Record, variable: Variable): unknown {
    if (!record || !variable) {
      return null;
    }
    const dataPoint: DataPoint | undefined = record.data.find((d) => d.value?.variable?.uri === variable.uri);
    if (!dataPoint) {
      return '';
    }
    const value = dataPoint.value?.value;

    if (instanceOfCode(value)) {
      switch (type) {
        case 'NAME':
          return value.name;
        case 'VALUE':
          return value.codeValue;
        default:
          return `${value.codeValue}: ${value.name}`;
      }
    } else {
      return value;
    }
  }
}
